import { BaseAuditLogEntry, ResourceType } from '../types/auditLogs.types';
import { ReadAuditLogsResponse } from '../types/auditLogsApi.types';

export function transformAuditLogsResponse<TResource extends ResourceType>(
  response: any,
): ReadAuditLogsResponse<TResource> {
  return {
    ...response,
    data: {
      logs: response.data.logs.map(
        ({ event, ...meta }): BaseAuditLogEntry<TResource> =>
          ({
            ...meta,
            event_id: meta.id,
            event_timestamp: meta.timestamp,
            ...event.payload,
            activity_type: event.type,
          }) as BaseAuditLogEntry<TResource>,
      ),
    },
  };
}
